import { render, staticRenderFns } from "./ResourceReferenceDialog.html?vue&type=template&id=45da1667&"
import script from "./ResourceReferenceDialog.js?vue&type=script&lang=js&"
export * from "./ResourceReferenceDialog.js?vue&type=script&lang=js&"
import style0 from "./ResourceReferenceDialog.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports